import { useNavigate, useParams } from 'react-router-dom';
import { Fragment, useEffect } from 'react';
import { setAccessToken } from '@partiu/api/axios.ts';

export function AutoLoginPage({ redirectTo = '/' }: { redirectTo?: string }) {
  const { token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) return;

    localStorage.removeItem('agreementId');

    setAccessToken(token);
    navigate(redirectTo);
  }, [token]);

  return <Fragment />;
}
